import React, { FC } from 'react';
// import payFeeUrl from '@/assets/home/image 162@2x.png';
// import parkingFeeUrl from '@/assets/home/image 161@2x.png';
// import topUpFeeUrl from '@/assets/home/image 163@2x.png';
// import warrantyUrl from '@/assets/home/image 164@2x.png';
// import guideUrl from '@/assets/home/image 165@2x.png';
// import announcementUrl from '@/assets/home/image 166@2x.png';
// import moreUrl from '@/assets/home/image 167@2x.png';
// import homeUrl from '@/assets/home/image168.png';
import styles from './index.less';
import { Divider } from 'react-vant';

export type OperationListListType = {
  label: string;
  icon: string;
  redirectUrl: string;
};

interface OperationListProps {
  quickClick: (value: string) => void;
  title: string;
  list: Array<any>;
}

const OperationList: FC<OperationListProps> = (props) => {
  const { quickClick, title, list } = props;

  return (
    <div className={styles['operation-container']}>
      <div className={styles['operation-container-title']}>{title}</div>
      <Divider className={styles['margin-0']}></Divider>
      <div className={styles['operation-container-box']}>
        {list.map((item) => (
          <div onClick={() => quickClick(item.redirectUrl)} key={item.label}>
            <img src={item.icon} alt={item.label} />
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OperationList;
